<template functional>
  <div
    :class="['site-loading', { activated: props.activated }]"
    style="z-index: 100">
    <div class="spinner">
      <div class="circle one"></div>
      <div class="circle two"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: ['activated'],
};
</script>
